interface IProps {
    active: boolean;
    critical: boolean;
    name: string;
    handleSetTsos: (tso: string) => void;
}

export const TsoCell = ({ active, critical, name, handleSetTsos }: IProps) => {
    return (
        <div
            id={`tso-cell-div-${name}`}
            className={active ? "tso-cell green" : critical ? "tso-cell yellow" : "tso-cell red"}
            onClick={() => handleSetTsos(name)}
        >
            {name}
        </div>
    );
};
